import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "©topanje",
  "description": "",
  "published": "2006-07-17T00:00:00.000Z",
  "redirect_from": ["/blog/topanje/swizec/395"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi, v èetrtek èe se izra¾anje stori natanèno, sem stopil v èudovito knjigarnico v katero ponavadi stopam, da dobim svoj redno potrebni fiks. Tam me je èakala, svetleèa, nova, lepa knjiga, ki sem jo bil naroèil, Štoparski Vodnik po Galaksiji. Knjiga je zelo lepo bralna, zelo dobro napisana in te marsikdaj pripravi do smeha. Govori se celo, da je tudi slovenski prevod prav odlièen in niè kaj prevodovsko slab. Dotièna izdaja, ki jo uporabljam, naj bi vsebovala kar pet romanov inu eno zgodbo... kar je precej veliko, pravzaprav kar 800 strani.`}</p>
    <p>{`Po drugi strani pa pod mojo posteljo mirno èaka gospod Cthulhu v mirnem prièakovanju nove epizode svojega stripa. Obljubim, da na le-tem delam s polno paro... no skoraj polno... in strip prav lepo napreduje in bi se lahko reklo, da je v boljšiligi kot prvi dve epizodi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      